var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.errored
      ? _c("section", { staticClass: "overlay" }, [_vm._m(0)])
      : _c(
          "section",
          [
            _vm.loading
              ? _c("div", { staticClass: "overlay" }, [
                  _c("p", { staticClass: "overlay-text loading-text" }, [
                    _vm._v("Loading...")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "loading-spacer" },
                    [
                      _c("vue-loading", {
                        attrs: {
                          type: "spiningDubbles",
                          color: "#FFF",
                          size: { width: "100px", height: "100px" }
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("Header"),
            _vm._v(" "),
            _c("div", { staticClass: "food-type" }, [
              _vm.page === 0
                ? _c("p", [_vm._v("主食")])
                : _vm.page < 11
                ? _c("p", [_vm._v("副食")])
                : _c("p", [_vm._v("水分量")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.loading,
                    expression: "!loading"
                  }
                ],
                staticClass: "panel-body"
              },
              [
                _vm.page < 11
                  ? _c("div", { staticClass: "meals" }, [
                      _c("div", { staticClass: "img-bg" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.q.img,
                            width: "2260",
                            height: "3116",
                            loding: "lazy"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", { staticClass: "answer" }, [
                        _c("img", {
                          staticClass: "yes",
                          attrs: {
                            src: require("@/assets/meal_entry/アセット 1@2x.png"),
                            width: "905",
                            height: "336",
                            loding: "lazy"
                          },
                          on: {
                            click: function($event) {
                              return _vm.answer(true)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "no",
                          attrs: {
                            src: require("@/assets/meal_entry/アセット 2@2x.png"),
                            width: "905",
                            height: "336",
                            loding: "lazy"
                          },
                          on: {
                            click: function($event) {
                              return _vm.answer(false)
                            }
                          }
                        })
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.page === 11
                  ? _c("InputWaterIntake", {
                      attrs: { ingestedWaterAmount: _vm.ingestedWaterAmount },
                      on: {
                        "handle-change-water": _vm.changeWater,
                        "handle-complete": _vm.pushedDone
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "back" },
              [
                0 < _vm.page
                  ? _c("img", {
                      staticClass: "go-back-one",
                      attrs: {
                        src: require("@/assets/meal_entry/アセット 3@2x.png"),
                        width: "884",
                        height: "336",
                        loding: "lazy"
                      },
                      on: { click: _vm.backOne }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("router-link", { attrs: { to: "/home" } }, [
                  _c("img", {
                    staticClass: "go-home",
                    attrs: {
                      src: require("@/assets/meal_entry/アセット 4@2x.png"),
                      width: "884",
                      height: "336",
                      loding: "lazy"
                    }
                  })
                ])
              ],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "overlay-text" }, [
      _vm._v("申し訳ありませんが、"),
      _c("br"),
      _vm._v("現時点ではこの情報を取得できません。"),
      _c("br"),
      _vm._v("しばらくしてからもう一度お試しください")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b02dccb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b02dccb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/RecordMeals.vue
// module id = null
// module chunks = 